var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 272,
    height: 30.249,
    viewBox: "0 0 272 30.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5587",
    "data-name": "Group 5587",
    transform: "translate(-437 -654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(437 654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M77.461,37.236a18.529,18.529,0,0,1-6.476-1.1,14.908,14.908,0,0,1-5.047-3.072,14.161,14.161,0,0,1-3.32-4.753,15.528,15.528,0,0,1-1.206-6.2,15.338,15.338,0,0,1,1.206-6.171,14.487,14.487,0,0,1,3.321-4.755,14.836,14.836,0,0,1,5.046-3.094,18.529,18.529,0,0,1,6.476-1.1H92.242V13.72H76.875a9.019,9.019,0,0,0-3.326.6,7.835,7.835,0,0,0-2.672,1.742,8.18,8.18,0,0,0-1.761,2.66,9.343,9.343,0,0,0,0,6.776,7.915,7.915,0,0,0,1.768,2.645,8.01,8.01,0,0,0,2.666,1.7,8.855,8.855,0,0,0,3.326.612H92.242v6.773Z",
    transform: "translate(-61.413 -6.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M171.331,37.236V6.994H178.5V30.463h19.284v6.773Z",
    transform: "translate(-138.48 -6.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M413.175,37.236V30.463h22.964a2.679,2.679,0,0,0,2.8-2.843,2.859,2.859,0,0,0-.793-2.106,2.73,2.73,0,0,0-2.007-.793H422.585a10.676,10.676,0,0,1-3.816-.66,8.891,8.891,0,0,1-2.985-1.806,8.042,8.042,0,0,1-1.931-2.753,9.139,9.139,0,0,1-.7-3.621,9.318,9.318,0,0,1,.7-3.65,8.333,8.333,0,0,1,1.932-2.807,8.493,8.493,0,0,1,2.969-1.791,11.049,11.049,0,0,1,3.828-.64H446V13.72H422.974a2.587,2.587,0,0,0-2.748,2.8,2.837,2.837,0,0,0,.754,2.04,2.623,2.623,0,0,0,1.993.8h13.558a10.829,10.829,0,0,1,3.841.66,9.329,9.329,0,0,1,2.986,1.833,8.206,8.206,0,0,1,1.946,2.8,9.182,9.182,0,0,1,.7,3.6,9.359,9.359,0,0,1-.7,3.687,8.308,8.308,0,0,1-1.952,2.831,8.57,8.57,0,0,1-2.974,1.825,11.03,11.03,0,0,1-3.848.638Z",
    transform: "translate(-308.033 -6.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M529.674,37.236V30.463h22.964a2.679,2.679,0,0,0,2.8-2.843,2.859,2.859,0,0,0-.793-2.106,2.73,2.73,0,0,0-2.007-.793H539.084a10.676,10.676,0,0,1-3.816-.66,8.887,8.887,0,0,1-2.985-1.806,8.038,8.038,0,0,1-1.931-2.753,9.138,9.138,0,0,1-.7-3.621,9.318,9.318,0,0,1,.7-3.65,8.333,8.333,0,0,1,1.932-2.807,8.493,8.493,0,0,1,2.969-1.791,11.049,11.049,0,0,1,3.828-.64H562.5V13.72H539.473a2.587,2.587,0,0,0-2.748,2.8,2.837,2.837,0,0,0,.754,2.04,2.624,2.624,0,0,0,1.994.8H553.03a10.831,10.831,0,0,1,3.841.66,9.33,9.33,0,0,1,2.986,1.833,8.206,8.206,0,0,1,1.946,2.8,9.182,9.182,0,0,1,.7,3.6,9.359,9.359,0,0,1-.7,3.687,8.307,8.307,0,0,1-1.952,2.831,8.57,8.57,0,0,1-2.974,1.825,11.029,11.029,0,0,1-3.848.638Z",
    transform: "translate(-389.714 -6.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M777.669,37.236a18.53,18.53,0,0,1-6.476-1.1,14.908,14.908,0,0,1-5.047-3.072,14.167,14.167,0,0,1-3.32-4.753,15.534,15.534,0,0,1-1.206-6.2,15.345,15.345,0,0,1,1.205-6.171,14.486,14.486,0,0,1,3.322-4.755,14.832,14.832,0,0,1,5.045-3.094,18.53,18.53,0,0,1,6.476-1.1h14.78V13.72H777.083a9.02,9.02,0,0,0-3.326.6,7.835,7.835,0,0,0-2.672,1.742,8.171,8.171,0,0,0-1.761,2.661,9.338,9.338,0,0,0,0,6.775,7.913,7.913,0,0,0,1.768,2.645,8.01,8.01,0,0,0,2.666,1.7,8.856,8.856,0,0,0,3.326.612H792.45v6.773Z",
    transform: "translate(-552.35 -6.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M300.575,37.241,287.487,13.084l-13.113,24.16H266.6L282.3,8.661a3.214,3.214,0,0,1,2.817-1.666h4.712a3.214,3.214,0,0,1,2.817,1.666l15.7,28.58Z",
    transform: "translate(-205.274 -6.995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M668.82,37.241,655.732,13.084,642.62,37.244h-7.778L650.549,8.661a3.213,3.213,0,0,1,2.817-1.666h4.712a3.214,3.214,0,0,1,2.817,1.666l15.7,28.58Z",
    transform: "translate(-463.461 -6.995)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 6.715,
    height: 10.525,
    transform: "translate(252.618 0.006) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 6.715,
    height: 10.525,
    transform: "translate(272 0.006) rotate(90)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 3.351,
    cy: 3.351,
    r: 3.351,
    transform: "translate(253.724 0.006)",
    fill: "#d71a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M913.262,33.077h0a3.541,3.541,0,0,1,3.541,3.541V55.525h-7.081V36.618a3.541,3.541,0,0,1,3.541-3.541Z",
    transform: "translate(-656.187 -25.282)",
    fill: "#d71a1a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5587bed77b54ec2f042f4f2f8df885d8.svg";
export { ForwardRef as ReactComponent };